import { Controller } from "@hotwired/stimulus"
import $ from 'jquery';

export default class extends Controller {
  static targets = ["submitBtn", "image", "userFormInputRole", "hiddenUserFormInputRole", "locationSelectWidget", "allLocationWidget"]

  connect() {
    this.button = this.element.querySelector("[data-bs-toggle='dropdown']");

    if (this.button) {
      this.button.addEventListener("show.bs.dropdown", this.show.bind(this));
      this.button.addEventListener("hide.bs.dropdown", this.hide.bind(this));
    }
  }

  roleChange(e) {
    const providerFields = e.target.closest('form').querySelector('.provider-fields');
    const commonFields = e.target.closest('form').querySelector('.common-fields');

    if (e.target.value) {
      commonFields.classList.remove('d-none');
      if (e.target.value == 'provider') {
        providerFields.classList.remove('d-none');
        this.toggleFields(providerFields.querySelectorAll('input, select'), false);
      } else {
        providerFields.classList.add('d-none');
        this.toggleFields(providerFields.querySelectorAll('input, select'), true);
      }
    } else {
      commonFields.classList.add('d-none');
      providerFields.classList.add('d-none');
    }

    this.toggleSubmitButton();
  }

  roleChangeCustom(e) {
    const providerFields = e.target.closest('form').querySelector('.provider-fields');
    const commonFields = e.target.closest('form').querySelector('.common-fields');

    const selectedRole = e.currentTarget.dataset.value
    const selectedRoleLabel = e.currentTarget.dataset.label

    if (selectedRole) {
      commonFields.classList.remove('d-none');
      if (selectedRole == 'provider') {
        providerFields.classList.remove('d-none');
        this.toggleFields(providerFields.querySelectorAll('input, select'), false);
      } else {
        providerFields.classList.add('d-none');
        this.toggleFields(providerFields.querySelectorAll('input, select'), true);
      }
    } else {
      commonFields.classList.add('d-none');
      providerFields.classList.add('d-none');
    }

    this.hiddenUserFormInputRoleTarget.value = selectedRole;
    this.userFormInputRoleTarget.value = selectedRoleLabel;

    (e.target.closest('.select-items').querySelectorAll('.checked-icon') || []).
    forEach(c => c.classList.add('d-none'))
    const checkedIcon = e.target.closest('.select-item').querySelector('.checked-icon')
    if (checkedIcon) checkedIcon.classList.remove('d-none')

    this.toggleSubmitButton();
  }

  toggleFields(fields, value) {
    if (value) {
      fields.forEach((field) => {
        field.setAttribute('disabled', '');
      });
    } else {
      fields.forEach((field) => {
        field.removeAttribute('disabled');
      });
    }
  }

  toggleSubmitButton() {
    if (!this.hasSubmitBtnTarget) return;

    const form = this.submitBtnTarget.closest('form');

    form.addEventListener('input', (_e) => {
      this.checkSubmitButton(form);
    });
    form.dispatchEvent(new Event('input'));

    form.querySelectorAll('select[required]').forEach((select) => {
      $(select).on('change', (e) => {
        this.checkSubmitButton(form);
      })
    });
  }

  submitBtnTargetConnected() {
    this.toggleSubmitButton();
  }

  checkSubmitButton(form) {
    const submitBtn = this.submitBtnTarget;
    const requiredInputFields = form.querySelectorAll('input[type=text][required]:not([disabled])');
    const requiredSelectFields = [];
    const selectFields = form.querySelectorAll('.select2-selection__rendered');
    selectFields.forEach((field) => {
      field.closest('.form-group').querySelectorAll('select[required]').forEach((select) => {
        requiredSelectFields.push(field);
      });
    });

    let allFieldsValid = true;
    requiredInputFields.forEach((field) => {
      if (field.value == '') {
        allFieldsValid = false;
      }
    });
    requiredSelectFields.forEach((field) => {
      if (field.closest('div').querySelectorAll('select:not([disabled])').length && field.innerText == '') {
        allFieldsValid = false;
      }
    });

    if (allFieldsValid) {
      submitBtn.classList.remove('btn-lock');
    } else {
      submitBtn.classList.add('btn-lock');
    }
  }

  show() {
    this.imageTarget.src = "/assets/select_location.svg";
  }

  hide() {
    this.imageTarget.src = "/assets/dropdown_location.svg";
  }

  setupLocationValidation() {
    const forms = document.querySelectorAll('form:has(select[name="user[location_ids][]"])');
    
    forms.forEach(form => {
      form.addEventListener('submit', (event) => {
        const locationSelect = form.querySelector('select[name="user[location_ids][]"]');
        
        if (locationSelect && locationSelect.selectedOptions.length === 0) {
          event.preventDefault();
          
          // Show error message
          let errorMessage = document.querySelector('.location-select-error');
          if (!errorMessage) {
            errorMessage = document.createElement('div');
            errorMessage.className = 'invalid-feedback d-block location-select-error';
            errorMessage.textContent = 'Please select at least one location.';
            locationSelect.parentNode.appendChild(errorMessage);
          }
          
          // Highlight the select2 container
          const select2Container = locationSelect.nextElementSibling;
          if (select2Container) {            
            // Scroll to the error
            select2Container.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      });
    });
  }

  toggleLocationSelectControl(e) {
    this.allLocationWidgetTarget.classList.toggle('d-none')
    this.locationSelectWidgetTarget.classList.toggle('d-none')
    const locationSelectType = e.target.dataset.locationSelectType 
    const select = this.locationSelectWidgetTarget.querySelector('select')
    $(select).val(null).trigger('change');
  }
}
